module.exports = __webpack_public_path__ + "img/item5.af86f74d.png";